import { SimplifiedResolverRegisterForm } from "domain/feature/hotsite/Forms/Register/v3"
import React from "react"
import { USER_TERMS_TYPE } from "sharedKernel/constants"
import { TReducers, useSelector } from "store"

export const HotsiteSimplifiedResolverRegisterPage = (): JSX.Element => {
  const registerFormState = useSelector((state: TReducers) => state.hotsiteIHotsiteRegisterFormState)
  const registerUrl = '/v1/system/create-resolver'

  return (
    <>
      <SimplifiedResolverRegisterForm registerFormStateProps={registerFormState} registerUrl={registerUrl} userType={USER_TERMS_TYPE.RESOLVER}/>
    </>
  )
}